var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stacked-bar-chart-card',{attrs:{"size":_vm.size,"title":"위험성 결정 현황","value":_vm.data,"init-total":_vm.total,"labels":_vm.labels,"x-axis":_vm.xAxis,"unit":"건","isMoveWrite":_vm.isMoveWrite,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }